import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { MaterialModule } from './modules/material.module';

/* Modules */
import { SpinnerContentModule } from '@app/shared/components/spinner-content/spinner-content.module';
// import { SharedComponentModule } from './components/shared-components.module';

@NgModule({
  imports: [CommonModule, MaterialModule, SpinnerContentModule],
  exports: [CommonModule, MaterialModule, SpinnerContentModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
